export default {"src":"/_next/static/media/arrow-right-hover.92963150.svg","height":32,"width":34,"blurWidth":0,"blurHeight":0};